'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _validation = require('utils/validation');

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _lodash = require('lodash');

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouter = require('react-router');

var _lib = require('helpers/lib');

var _Constant = require('helpers/Constant');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountInfo = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    success: state.user.success
  };
}, (0, _extends3.default)({}, userActions, authActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AccountInfo, _Component);

  function AccountInfo() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AccountInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccountInfo.__proto__ || (0, _getPrototypeOf2.default)(AccountInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      newUser: {
        _id: _this.props.user._id,
        email: _this.props.user.email,
        name: _this.props.user.profile.name,
        avatar: _this.props.user.profile.picture,
        dob: _this.props.user.profile.dob,
        phone: _this.props.user.phone,
        verifiedEmail: _this.props.user.verifiedEmail,
        verifiedPhone: _this.props.user.verifiedPhone,
        gender: _this.props.user.profile.gender,
        isUpdatedAvatar: false
      },
      avatar: [],
      errors: {},
      validation: {},
      edited: false
    }, _this.handleChange = function (event) {
      var field = event.target.name;
      var value = event.target.value;
      if (event.target.type === 'checkbox') {
        value = event.target.checked;
      }
      var obj = _this.state.newUser;
      obj[field] = value;
      _this.setState({ newUser: obj, edited: true });
    }, _this.onSubmit = function (event) {
      event.preventDefault();
      var surveyValidation = (0, _validation.createValidator)({
        name: [_validation.required],
        email: [_validation.email]
      });
      var errors = surveyValidation(_this.state.newUser);
      if ((0, _lodash.isEmpty)(errors)) {
        _this.setState({ validation: {} });
        var newUser = _this.state.newUser;
        var name = (0, _lib.encrypt)((0, _lib.createImageName)({
          user: newUser._id,
          type: 'avatar'
        }));
        newUser.encryptName = name;
        _this.props.updateUser(_this.state.newUser, _this.state.avatar);
      } else {
        _this.setState({ validation: errors });
      }
    }, _this.handleModalSuccess = function () {
      _this.setState({
        showModalSuccess: !_this.state.showModalSuccess
      });
    }, _this.onBack = function () {
      _reactRouter.browserHistory.goBack();
    }, _this.responsePhone = function (response) {
      _this.props.activePhone(response);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AccountInfo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.success) {
        this.props.clearSuccessStatus();
        this.handleModalSuccess();
        this.props.loadAuth();
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      var obj = this.state.newUser;
      obj.isUpdatedAvatar = true;
      this.setState({ newUser: obj, avatar: acceptedFiles, edited: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./AccountInfo.scss');
      var user = this.props.user;
      var _state = this.state,
          newUser = _state.newUser,
          showModalSuccess = _state.showModalSuccess,
          avatar = _state.avatar,
          validation = _state.validation,
          errors = _state.errors;

      return _react2.default.createElement(
        'div',
        { className: styles.accountInfo },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          'Th\xF4ng tin t\xE0i kho\u1EA3n'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.formInfo },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'form',
                { className: 'form form-horizontal' },
                _react2.default.createElement(
                  'div',
                  { className: 'form-group' },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    '\u1EA2nh \u0111\u1EA1i di\u1EC7n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    _react2.default.createElement(
                      _reactDropzone2.default,
                      {
                        className: 'dropzone',
                        onDrop: this.onDrop.bind(this),
                        accept: 'image/*',
                        multiple: false,
                        style: { float: 'left', marginRight: '10px' }
                      },
                      newUser.isUpdatedAvatar && avatar.length > 0 && _react2.default.createElement(
                        'div',
                        { style: { float: 'left' } },
                        avatar.map(function (image) {
                          var imgBackGr = {
                            backgroundImage: 'url:(' + image.preview + ')'
                          };
                          return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                            'div',
                            { key: image.lastModified },
                            _react2.default.createElement('video', {
                              src: image.preview,
                              key: image.lastModified,
                              width: '100%',
                              height: '250px',
                              controls: true
                            })
                          ) : _react2.default.createElement('img', {
                            src: image.preview,
                            key: image.lastModified,
                            style: imgBackGr,
                            className: styles.avatar
                          });
                        })
                      ),
                      !newUser.isUpdatedAvatar && newUser.avatar && _react2.default.createElement(
                        'div',
                        { style: { float: 'left' } },
                        _react2.default.createElement('img', {
                          src: (0, _lib.getUrlImage)(newUser.avatar),
                          style: {
                            backgroundImage: 'url:(' + (0, _lib.getUrlImage)(newUser.avatar) + ')'
                          },
                          className: styles.avatar
                        })
                      ),
                      !newUser.isUpdatedAvatar && !newUser.avatar && _react2.default.createElement(
                        'div',
                        { style: { float: 'left' } },
                        _react2.default.createElement('img', {
                          src: _Constant.defaultAvatar,
                          style: {
                            backgroundImage: 'url:(' + _Constant.defaultAvatar + ')'
                          },
                          className: styles.avatar
                        })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'form-group' + (!(0, _lodash.isEmpty)(validation) && validation.name || !(0, _lodash.isEmpty)(errors) && errors.name ? ' has-error' : '')
                  },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    'T\xEAn'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    _react2.default.createElement('input', {
                      className: 'form-control ' + styles.fullWidth,
                      type: 'text',
                      name: 'name',
                      value: newUser.name,
                      onChange: this.handleChange
                    }),
                    !(0, _lodash.isEmpty)(validation) && validation.name && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      validation.name
                    ),
                    !(0, _lodash.isEmpty)(errors) && errors.name && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      errors.name
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'form-group' + (!(0, _lodash.isEmpty)(validation) && validation.dob || !(0, _lodash.isEmpty)(errors) && errors.dob ? ' has-error' : '')
                  },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    'Ng\xE0y sinh'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    _react2.default.createElement('input', {
                      className: 'form-control',
                      type: 'date',
                      name: 'dob',
                      value: (0, _moment2.default)(new Date(newUser.dob)).format('YYYY-MM-DD'),
                      style: {
                        width: '160px',
                        textAlign: 'right',
                        height: '40px'
                      },
                      onChange: this.handleChange
                    }),
                    !(0, _lodash.isEmpty)(validation) && validation.dob && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      validation.dob
                    ),
                    !(0, _lodash.isEmpty)(errors) && errors.dob && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      errors.dob
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'form-group' + (!(0, _lodash.isEmpty)(validation) && validation.gender || !(0, _lodash.isEmpty)(errors) && errors.gender ? ' has-error' : '')
                  },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    'Gi\u1EDBi t\xEDnh'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    _react2.default.createElement(
                      'select',
                      {
                        className: 'form-control',
                        placeholder: 'Gi\u1EDBi t\xEDnh',
                        name: 'gender',
                        style: {
                          width: '160px',
                          textAlign: 'right',
                          height: '40px'
                        },
                        value: newUser.gender,
                        onChange: this.handleChange
                      },
                      _react2.default.createElement(
                        'option',
                        { value: 'female' },
                        'N\u1EEF'
                      ),
                      _react2.default.createElement(
                        'option',
                        { value: 'male' },
                        'Nam'
                      ),
                      _react2.default.createElement(
                        'option',
                        { value: 'other' },
                        'Kh\xE1c'
                      )
                    ),
                    !(0, _lodash.isEmpty)(validation) && validation.gender && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      validation.gender
                    ),
                    !(0, _lodash.isEmpty)(errors) && errors.gender && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      errors.gender
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'form-group' + (!(0, _lodash.isEmpty)(validation) && validation.email || !(0, _lodash.isEmpty)(errors) && errors.email ? ' has-error' : '')
                  },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    'Email'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    user && !user.verifiedEmail ? _react2.default.createElement('input', {
                      className: 'form-control ' + styles.fullWidth,
                      type: 'text',
                      name: 'email',
                      value: newUser.email,
                      onChange: this.handleChange
                    }) : _react2.default.createElement(
                      'div',
                      { style: { lineHeight: '40px' } },
                      user && user.email
                    ),
                    !(0, _lodash.isEmpty)(validation) && validation.email && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      validation.email
                    ),
                    !(0, _lodash.isEmpty)(errors) && errors.email && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      errors.email
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'form-group' + (!(0, _lodash.isEmpty)(validation) && validation.phone || !(0, _lodash.isEmpty)(errors) && errors.phone ? ' has-error' : '')
                  },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-sm-3 control-label' },
                    'Phone'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-9' },
                    user && _react2.default.createElement(
                      'div',
                      { style: { lineHeight: '40px' } },
                      user.phone
                    ),
                    user && user.phone && !user.verifiedPhone && _react2.default.createElement(
                      _FirebaseAuth2.default,
                      { desktopMode: true, onResponse: this.responsePhone },
                      function (p) {
                        return _react2.default.createElement(
                          'button',
                          (0, _extends3.default)({}, p, { type: 'button', className: styles.phone }),
                          _react2.default.createElement('i', {
                            className: 'fa fa-check ' + styles.icon,
                            'aria-hidden': 'true'
                          }),
                          'X\xE1c th\u1EF1c s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                        );
                      }
                    ),
                    user && !user.phone && !user.verifiedPhone && _react2.default.createElement(
                      _FirebaseAuth2.default,
                      { desktopMode: true, onResponse: this.responsePhone },
                      function (p) {
                        return _react2.default.createElement(
                          'button',
                          (0, _extends3.default)({}, p, { type: 'button', className: styles.phone }),
                          _react2.default.createElement('i', {
                            className: 'fa fa-plus ' + styles.icon,
                            'aria-hidden': 'true'
                          }),
                          'Th\xEAm s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                        );
                      }
                    ),
                    !(0, _lodash.isEmpty)(validation) && validation.phone && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      validation.phone
                    ),
                    !(0, _lodash.isEmpty)(errors) && errors.phone && _react2.default.createElement(
                      'small',
                      { className: 'help-block' },
                      errors.phone
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-group' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'col-sm-9 col-sm-offset-3',
                      style: { textAlign: 'left' }
                    },
                    _react2.default.createElement(
                      'button',
                      {
                        className: styles.buttonSave,
                        type: 'submit',
                        onClick: this.onSubmit
                      },
                      'L\u01AFU TH\xD4NG TIN'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal,
            {
              show: showModalSuccess,
              hide: this.handleModalSuccess,
              className: 'modal-alert-login'
            },
            _react2.default.createElement(
              'div',
              {
                className: 'close-modal-button',
                onClick: this.handleModalSuccess
              },
              _react2.default.createElement('i', { className: 'fa fa-times' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.modalAlert },
              _react2.default.createElement(
                'div',
                { className: styles.headerAlert },
                'Th\xF4ng b\xE1o'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.contentAlert },
                'C\u1EADp nh\u1EADt th\xF4ng tin t\xE0i kho\u1EA3n th\xE0nh c\xF4ng'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.actionButtons },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.btnLogin,
                    onClick: this.handleModalSuccess
                  },
                  'X\xE1c nh\u1EADn'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AccountInfo;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  updateUser: _react.PropTypes.func.isRequired,
  success: _react.PropTypes.bool,
  clearSuccessStatus: _react.PropTypes.func,
  load: _react.PropTypes.func,
  activePhone: _react.PropTypes.func,
  loadAuth: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = AccountInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/AccountInfo.js
// module id = 1500
// module chunks = 0